import { PATHNAME } from 'utils';

const {
  DEFAULT: { LOCALE: DEFAULT_LOCALE },
} = PATHNAME;

const numberFormat = (
  value: number,
  options: Intl.NumberFormatOptions = {
    style: 'decimal',
  },
  addonAfter = '',
  locales: string | string[] = DEFAULT_LOCALE,
) => new Intl.NumberFormat(locales, options).format(value).concat(addonAfter);

const dateTimeFormat = (
  date: Date | number,
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  },
  addonAfter = '',
  locales: string | string[] = DEFAULT_LOCALE,
) => new Intl.DateTimeFormat(locales, options).format(date).concat(addonAfter);

const discountPercentage = (
  originalPrice: number,
  price: number,
  addonAfter = '',
  locales: string | string[] = DEFAULT_LOCALE,
) =>
  numberFormat(
    (1 / originalPrice) * (originalPrice - price),
    { style: 'percent' },
    addonAfter,
    locales,
  );

const localeSortByKey = <T extends Record<K, unknown>, K extends keyof T>(
  data: T[],
  key: K,
  direction: 'asc' | 'desc' = 'asc',
  locales: string | string[] = DEFAULT_LOCALE,
  collatorOptions?: Intl.CollatorOptions,
): T[] => {
  // Create a copy to avoid mutating the original array
  const clonedData = [...data];
  const intlCollator = new Intl.Collator(locales, collatorOptions);
  const isDescendingDirection = direction === 'desc';

  const result = clonedData.sort((firstItem, secondItem) => {
    const firstValue = String(firstItem[key]);
    const secondValue = String(secondItem[key]);

    const comparison = intlCollator.compare(firstValue, secondValue);

    return isDescendingDirection ? -comparison : comparison;
  });

  return result;
};

export { dateTimeFormat, discountPercentage, localeSortByKey, numberFormat };
